// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".unvergessen-col[data-v-30406d62]{padding-top:0;padding-bottom:0;padding-right:0}.unvergessen-message[data-v-30406d62]{background-color:#f0f0f0;font-style:bold}", ""]);
// Exports
module.exports = exports;
